/* eslint-disable react/jsx-props-no-spreading */
import React, { type SVGProps } from 'react';

const PlayIconLg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={30}
    fill="none"
    {...props}
    data-palette="PlayIconLg">
    <g clipPath="url(#playIconLgA)">
      <path
        fill="#fff"
        d="M15 27.5C8.096 27.5 2.5 21.904 2.5 15S8.096 2.5 15 2.5 27.5 8.096 27.5 15 21.904 27.5 15 27.5Zm0-2.5a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm-1.723-14.481 6.1 4.065a.5.5 0 0 1 0 .832l-6.1 4.065a.5.5 0 0 1-.777-.415v-8.132a.501.501 0 0 1 .777-.415Z"
      />
    </g>
    <defs>
      <clipPath id="playIconLgA">
        <path fill="#fff" d="M0 0h30v30H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default PlayIconLg;
